export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", seq: "cat-shoes-01" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", seq: "cat-hoodies-01" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", seq: "cat-tshirts-01" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", seq: "cat-jackets-01" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", seq: "cat-pants-01" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", seq: "cat-headwear-01" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", seq: "cat-sets-01" },
  { name: "Underwear/Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", seq: "cat-underwear-01" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", seq: "cat-jersey-01" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", seq: "cat-accessories-01" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", seq: "cat-bags-01" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", seq: "cat-belts-01" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", seq: "cat-perfumes-01" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", seq: "cat-otherstuff-01" },
];

export const siteConfig = {
  siteName: "GTBuy Spreadsheet",
  siteUrl: "https://gtbuyspreadsheet.icu",
  mainSiteUrl: "https://kaspreadsheet.com",
  mainSiteName: "KASpreadsheet",
};